<template>
  <div class="article_6">
   <Navigation></Navigation>

    <div class="article_header">       
        <div class=col_1>    
          <h1 v-if="$global.global_ru">АВТОРСКОЕ ПРАВО</h1>  
          <h1 v-if="$global.global_kz">АВТОРЛЫҚ ҚҰҚЫҚ</h1>  

          <h2 v-if="$global.global_ru"><span>Основные проблемы:</span></h2>
          <h2 v-if="$global.global_kz"><span>Негізгі мәселелер:</span></h2>
   
          <p v-if="$global.global_ru">В основном, журналисты отмечают регулярные нарушения их авторских прав. Как правило, это перепечатки материалов без разрешения или уведомления, отсутствие ссылок, неактивные ссылки, ссылки на не оригинал материала. Районные издания нередко перепечатывают материалы областных газет, причем могут вставить свое фото и представить это как собственный материал. То же происходит и наоборот. </p>
          <p v-if="$global.global_kz">Журналистер авторлық құқықтарының жиі бұзылатынын айтады. Әдетте, олардың қатарында материалдарды рұқсатсыз немесе ескертусіз көшіріп басу, сілтеменің болмауы, белсенді емес сілтеме, материалдың түпнұсқасына сілтеменің болмауы секілді бұзушылықтар бар. Аудандық басылымдар облыстық газеттердегі материалдарды көшіріп алып, өз суретін қоса жариялар, өз материалы ретінде ұсына салады. Кейде керісінше болып жатады.</p>          
      </div>


    <div class=col_2>
        <img alt="" src="../assets/img/06.png" /> 
      </div>
    </div>


    <div class="text_container">   
      <div class="mobile_only">
          <h2 v-if="$global.global_ru"><span>Основные проблемы:</span></h2>
          <h2 v-if="$global.global_kz"><span>Негізгі мәселелер:</span></h2>
   
          <p v-if="$global.global_ru">В основном, журналисты отмечают регулярные нарушения их авторских прав. Как правило, это перепечатки материалов без разрешения или уведомления, отсутствие ссылок, неактивные ссылки, ссылки на не оригинал материала. Районные издания нередко перепечатывают материалы областных газет, причем могут вставить свое фото и представить это как собственный материал. То же происходит и наоборот. </p>
          <p v-if="$global.global_kz">Журналистер авторлық құқықтарының жиі бұзылатынын айтады. Әдетте, олардың қатарында материалдарды рұқсатсыз немесе ескертусіз көшіріп басу, сілтеменің болмауы, белсенді емес сілтеме, материалдың түпнұсқасына сілтеменің болмауы секілді бұзушылықтар бар. Аудандық басылымдар облыстық газеттердегі материалдарды көшіріп алып, өз суретін қоса жариялар, өз материалы ретінде ұсына салады. Кейде керісінше болып жатады.</p>  
      </div> 

      <!-- RU version main text -->
      <div v-if="$global.global_ru">
        <p>В некоторых регионах распространена практика, когда блогеры открывают информационные агентства и перепечатывают материалы без указания авторства и без ссылок. </p>

        <p>Многие журналисты отметили, что не реагируют на такие случаи: «Все равно мы были первые, и читатели это знают». Другие пишут жалобы в инстаграм, в полицию. В Актобе это дало положительный эффект, когда паблик в инстаграме был наказан, и незаконные перепечатки прекратились. </p>

        <p>К положительной практике можно отнести то, когда журналисты звонят друг другу и спрашивают, можно ли опубликовать материал. Так же существуют «джентльменские соглашения», когда это делается обязательно со ссылками. </p>

        <p>Самая большая и распространенная проблема – перепечатка материалов без указания авторства в различных пабликах в инстаграме, у которых численность аудитории намного больше, чем у СМИ. Например, численность аудитории у аккаунта СМИ 180 000, а у паблика – 300 000. Журналисты отмечают, что найти владельца паблика практически невозможно, и все остается безнаказанным. Причем многие после указания на нарушения снова занимаются плагиатом. </p>

        <p class="qoute">«Наши материалы в основном воруют местные паблики в соцсетях, которые не указывают ссылку на первоисточник. Просьбу или замечания они тупо игнорируют.  Паблики не зарегистрированы, их данные сложно найти» </p>     
              
        <div class="highlight">
          <h2><span>Что делать?</span></h2>
          <ul>
              <li>Регулировать деятельность пабликов в социальных сетях в части соблюдения авторских прав и рекламы </li>
              <li>Инициировать судебные разбирательства в случае нарушения авторских прав</li>      
          </ul>
        </div>
      </div>


      <!-- KZ version main text -->
      <div v-if="$global.global_kz">
        <p>Бірқатар өңірлерде блогерлер ақпараттық агенттік ашып алады да, материалдардың авторын көрсетпей, сілтеме жасамай көшіріп басады.  </p>

        <p>Журналистердің біразы «Бәрібір біз бірінші жарияладық, оқырман біледі» деп мән бере қоймайды. Басқалары инстграм әкімшілігіне шағым жолдайды, полицияға хабарласады. Ақтөбеде бұл әдіс тиімділігін көрсетті, пабликке шара қолданылды, заңсыз көшіріп басу тоқтады.  </p>

        <p>Журналистер арасында бір-біріне хабарласып, материалды жариялауға рұқсат сұрап жататын оң үрдіс бар. Сонымен бірге, міндетті түрде сілтеме көрсетіп, жариялайтын «джентльмендік келісім» де кезігеді.  </p>

        <p>Ең үлкен әрі кеңінен тараған мәселе – түрлі пабликтерде авторлықты көрсетпей көшіріп басу. Ол пабликтердегі оқырман саны БАҚ оқырманы санынан да көп болуы мүмкін. Мәселен, БАҚ аккаунтына жазылғандар саны 180 000, ал пабликті 300 000 адам оқиды. Паблик иелерін табу өте қиын, мүмкін емес, нәтижесінде оларға шара қолдану мүмкін болмайды. Бұзушылық туралы ескерту алса да, кейін плагиатпен айналысатындары бар. </p>

        <p class="qoute">«Біздің материалдарды негізінен әлеуметтік желілердегі жергілікті пабликтер ұрлайды, алғаш жарияланған дереккөзге сілтеме жасамайды. Өтініш не ескертуге құлақ аспайды. Пабликтер тіркелмеген, олар туралы мәлімет табу қиын» </p>     
              
        <div class="highlight">
          <h2><span>Не істеу керек?</span></h2>
          <ul>
              <li>Әлеуметтік желілердегі пабликтер қызметін, әсіресе, авторлық құқық сақтау және жарнама жағынан реттеу керек</li>
              <li>Авторлық құқық бұзылған жағдайда сотта қарау жөнінде бастама көтеру керек</li>      
          </ul>
        </div>
      </div>


    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navigation from "@/components/imageNavigation.vue";
import Footer from "@/components/Footer.vue";

import { scale } from "../assets/js/variables.js"


export default {
  components: {
    Navigation, Footer   
    },
     mounted(){
      var imageNav = document.querySelector(".imageNav");
      var item = imageNav.querySelector(".choose_article");
      var imageIcons = item.getElementsByClassName("article-item");           
      imageIcons[5].style.transform = scale;         
    }
  }
</script>


<style lang="scss" scoped>
    $color: #3d4a93;

.article_header {
        background-color:$color;

  h2 span {
        background-color: white;
        color: $color;
  }
}

.text_container {
  h2 span {
        background-color: $color;
  }

  p.qoute {   
        color: $color;
        border-left: 5px solid $color;
  }
}   

.highlight {      
      background-color: #3d4a9333;
    }

 ul li:before {      
      color: $color;      
    }
</style>
